export const ELEMENT_NOT_FOUND_DIALOG = {
  CONTAINER: 'element-not-found-dialog-container',
  CLOSE_BUTTON: 'element-not-found-dialog-close-button',
  OK_BUTTON: 'element-not-found-dialog-ok-button'
} as const;
